import { render, staticRenderFns } from "./MedicalAffiliateUrl.vue?vue&type=template&id=0fa0f4da"
import script from "./MedicalAffiliateUrl.vue?vue&type=script&lang=js"
export * from "./MedicalAffiliateUrl.vue?vue&type=script&lang=js"
import style0 from "./MedicalAffiliateUrl.vue?vue&type=style&index=0&id=0fa0f4da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports